export const IMPORT_OPTION_ID = {
  BASE_SYSTEM: "import-base-system",
  TEMPLATE: "import-template",
} as const;
